
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 7a3 3 0 013-3h5a3 3 0 013 3v5a3 3 0 01-3 3H7a3 3 0 01-3-3V7z","fill":"#B4BCCF"}}),_c('path',{attrs:{"d":"M4 20a3 3 0 013-3h5a3 3 0 013 3v5a3 3 0 01-3 3H7a3 3 0 01-3-3v-5z","fill":"#525F7F"}}),_c('path',{attrs:{"d":"M17 20a3 3 0 013-3h5a3 3 0 013 3v5a3 3 0 01-3 3h-5a3 3 0 01-3-3v-5zM22.99 4.172c.14.11.237.266.276.44l.435 1.911a2.357 2.357 0 001.776 1.776l1.912.435a.786.786 0 010 1.532l-1.912.435a2.357 2.357 0 00-1.776 1.776l-.435 1.912a.786.786 0 01-1.532 0l-.435-1.912a2.358 2.358 0 00-1.776-1.776l-1.912-.435a.785.785 0 010-1.532l1.912-.435A2.357 2.357 0 0021.3 6.523l.435-1.912a.786.786 0 011.256-.44z","fill":"#B4BCCF"}})])
          )
        }
      }
    